document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('quick-view-modal');
  const modalContent = document.getElementById('quick-view-data');
  const brandLogos = {
    "Sanremo": "sanremo-pcg.svg",
    "Astoria": "astoria-pcg.svg",
    "Astoria Parts": "astoria-pcg.svg",
    "Baratza": "baratza-pcg.svg",
    "HeyCafe": "HeyCafe.svg",
    "Macap": "macap.svg",
    "Barista Attitude": "barista attitude-pcg.svg",
    "Compak": "compak-pcg.svg",
    "Ditting": "ditting-pcg.svg",
    "ECM": "ecm-pcg.svg",
    "Egro": "egro-pcg.svg",
    "Eureka": "Eureka-pcg.svg",
    "Eureka Parts": "Eureka-pcg.svg",
    "Eversys": "eversys-pcg.svg",
    "Eversys Accessory": "eversys-pcg.svg",
    "Eversys Cleaning": "eversys-pcg.svg",
    "Faema": "faema-pcg.svg",
    "Faema Parts": "faema-pcg.svg",
    "Fetco": "fetco-pcg.svg",
    "Fiorenzato": "fiorenzato-pcg.svg",
    "Ground Control": "ground-control-pcg.svg",
    "Kees Van Der Westen": "kees-van-der westen-pcg.svg",
    "La Cimbali": "la-cimbali-pcg.svg",
    "La Cimbali Parts": "la-cimbali-pcg.svg",
    "La Marzocco": "la-marzocco-pcg.svg",
    "Mahlkonig": "mahlkonig-pcg.svg",
    "Marco": "marco-pcg.svg",
    "Mavam": "mvw-pcg.svg",
    "Mazzer": "mazzer-pcg.svg",
    "Nuova Simonelli": "nuova-pcg.svg",
    "Nuova Simonelli Grinders": "nuova-pcg.svg",
    "Nuova Simonelli Parts": "nuova-pcg.svg",
    "Omnipure": "omnipure-pcg.svg",
    "Perfect Moose": "perfect-moose-pcg.svg",
    "Profitec": "profitec-pcg.svg",
    "PUQ": "puq-pcg.svg",
    "PUQ Parts": "puq-pcg.svg",
    "Rancilio": "rancilio-group-pcg.svg",
    "Rocket": "rocket-pcg.svg",
    "Rocket Parts": "rocket-pcg.svg",
    "Rocket Espresso": "rocket-pcg.svg",
    "Slayer": "slayer-pcg.svg",
    "Superkop": "superkop-pcg.svg",
    "Synesso": "synesso-pcg.svg",
    "Unic": "unic-pcg.svg",
    "Urnex": "urnex-pcg.svg",
    "Victoria Arduino": "victoria-pcg.svg",
    "Victoria Arduino Grinders": "victoria-pcg.svg",
    "Victoria Arduino Parts": "victoria-pcg.svg",
    "Wega": "wega-pcg.svg",
    "Wega Parts": "wega-pcg.svg",
    "Anfim": "anfim.svg",
    "BFC": "bfc.svg",
    "Brugnetti": "brugnetti.svg",
    "Brugnetti Parts": "brugnetti.svg",
    "Casadio": "casadio.svg",
    "Ceado": "ceado.svg",
    "Dalla Corte": "dallaCorte.svg",
    "Elektra": "elektra.svg",
    "Enhanced Beverage Solutions": "eBS.svg",
    "Everpure": "everpure.svg",
    "Expobar": "expobar.svg",
    "Fiamma": "fiamma.svg",
    "Iberital": "Iberital.svg",
    "Kinetico Pro": "kinetico-pro.svg",
    "La Spaziale": "laSpaziale.svg",
    "La Spaziale Parts": "laSpaziale.svg",
    "Magister": "magister.svg",
    "Poursteady": "poursteady.svg",
    "San Marino": "sanMarino.svg",
    "San Marco": "SanMarco.svg",
    "SAN MARCO Parts": "SanMarco.svg"
  };

  function renderBrandLogo(productType) {
    const logoFile = brandLogos[productType];
    if (!logoFile) return '';
  
    const logoUrl = `/assets/${logoFile}`; // adjust if you're using a different folder
    return `<div class="brand_logo_pdp text-center">
              <img src="${logoUrl}" alt="${productType} logo" />
            </div>`;
  }

  function closeModal() {
    modal.style.display = 'none';
    modalContent.innerHTML = '';
  }

  // function initializeSlick(images) {
  //   if (!$('.product__image-slider').hasClass('slick-initialized')) {
  //     $('.product__image-slider').slick({
  //       slidesToShow: 1,
  //       slidesToScroll: 1,
  //       arrows: false,
  //       fade: false,
  //       asNavFor: '.product__image-thumbnail',
  //       adaptiveHeight: true,
  //       infinite: true,
  //     });
  //   }

  //   const imageCount = images.length;
  //   let thumbSlides = 1;
  //   if (imageCount === 2) thumbSlides = 1;
  //   else if (imageCount === 3) thumbSlides = 2;
  //   else if (imageCount === 4) thumbSlides = 3;
  //   else if (imageCount > 4) thumbSlides = 4;

  //   if (!$('.product__image-thumbnail').hasClass('slick-initialized')) {
  //     $('.product__image-thumbnail').slick({
  //       slidesToShow: thumbSlides,
  //       slidesToScroll: 1,
  //       asNavFor: '.product__image-slider',
  //       dots: false,
  //       arrows: true,
  //       infinite: true,
  //       centerMode: false,
  //       focusOnSelect: true,
  //       prevArrow: `<button class="flickity-button flickity-prev-next-button previous"></button>`,
  //       nextArrow: `<button class="flickity-button flickity-prev-next-button next"></button>`,
  //       responsive: [
  //         {
  //           breakpoint: 600,
  //           settings: {
  //             slidesToShow: imageCount === 2 ? 2 : (imageCount >= 3 ? 3 : 1)
  //           }
  //         },
  //         {
  //           breakpoint: 420,
  //           settings: {
  //             slidesToShow: 2
  //           }
  //         }
  //       ]
  //     });
  //   }

  //   $('.product__image-slider').slick('setPosition');
  //   $('.product__image-thumbnail').slick('setPosition');

  //   $('.previous').on('click', function () {
  //     $('.product__image-slider').slick('slickPrev');
  //   });

  //   $('.next').on('click', function () {
  //     $('.product__image-slider').slick('slickNext');
  //   });
  // }

  function getThumbnailCount(images) {
    const count = images.length;
    if (count === 2) return 1;
    if (count === 3) return 2;
    if (count === 4) return 3;
    return 4;
  }

  function openModal(product) {
    modal.style.display = 'block';
    const images = product.images;

    requestAnimationFrame(() => {
      setTimeout(() => {
        const $mainSlider = $(".product__image-slider");
        const $thumbSlider = $(".product__image-thumbnail");
        $(".product__image-slider").not('.slick-initialized').slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          fade: false,
          asNavFor: '.product__image-thumbnail',
          adaptiveHeight: true,
          infinite: true,
        });

        $(".product__image-thumbnail").not('.slick-initialized').slick({
          slidesToShow: getThumbnailCount(images),
          slidesToScroll: 1,
          asNavFor: '.product__image-slider',
          infinite: true,
          dots: false,
          centerMode: false,
          focusOnSelect: true,
          arrows: true,
          prevArrow: `<button class="flickity-button flickity-prev-next-button previous"></button>`,
          nextArrow: `<button class="flickity-button flickity-prev-next-button next"></button>`,
          responsive: [
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 420,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });

         // 1. Call setPosition immediately after init.
          $mainSlider.slick('setPosition');
          $thumbSlider.slick('setPosition');

          // 2. If images are still loading, setPosition again after they load.
          // This is a more robust way to handle adaptiveHeight with images.
          const $sliderImages = $mainSlider.find('img');
          if ($sliderImages.length > 0) {
              let loadedImages = 0;
              $sliderImages.each(function() {
                  if (this.complete) {
                      loadedImages++;
                  } else {
                      $(this).on('load error', function() { // also handle error to avoid hanging
                          loadedImages++;
                          if (loadedImages >= $sliderImages.length) {
                              $mainSlider.slick('setPosition'); // Re-calculate height
                              // console.log('All images loaded, setPosition called');
                          }
                      });
                  }
              });
              // If all images were already complete (e.g., cached)
              if (loadedImages >= $sliderImages.length) {
                  $mainSlider.slick('setPosition');
                  // console.log('All images were cached, setPosition called');
              }
          } else {
               // If no images, still call setPosition, though adaptiveHeight might not be relevant
               $mainSlider.slick('setPosition');
          }


          // Event handlers: .off() to prevent multiple bindings if modal is re-opened
          $('.previous').off('click.slicknav').on('click.slicknav', function () {
              $mainSlider.slick('slickPrev');
          });

          $('.next').off('click.slicknav').on('click.slicknav', function () {
              $mainSlider.slick('slickNext');
          });

        // $(".product__image-slider").slick('setPosition');
        // $(".product__image-thumbnail").slick('setPosition');
        
        // $('.previous').on('click', function () {
        //   $('.product__image-slider').slick('slickPrev');
        // });
    
        // $('.next').on('click', function () {
        //   $('.product__image-slider').slick('slickNext');
        // });
      }, 100);
    });
  }

  $(window).resize(function () {
    if ($("#quick-view-modal").is(":visible")) {
      $(".product__image-slider").slick("setPosition");
      $(".product__image-thumbnail").slick("setPosition");
    }
  });

  function formatPrice(price) {
    return "$" + (price / 100).toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function buildQuickView(product, shortfeatures) {
    const variants = product.variants;
    const firstVariant = variants[0];
    const images = product.images;
    const productHandle = product.url;
    const price = formatPrice(firstVariant.price);
    const logoUrl = window.brandLogos?.[product.type];
    var desc = product.description;
    const imagesCount = getThumbnailCount(images);

    let maxWidthStyle = '';
    if (imagesCount === 1) {
      maxWidthStyle = 'style="max-width: 235px;"';
    } else if (imagesCount === 2) {
      maxWidthStyle = 'style="max-width: 323px;"';
    } else if (imagesCount === 3) {
      maxWidthStyle = 'style="max-width: 323px;"';
    }

    console.log(imagesCount);

    
    let featuresHtml = '';
      if (shortfeatures) {
        try {
          const features = JSON.parse(shortfeatures);
          featuresHtml = `
            <div class="short-features">
              <ul class="collection_card_charac new_collection_card_charac">
                ${features.map(feature => `<li>${feature}</li>`).join('')}
              </ul>
            </div>
          `;
        } catch(error) {
          console.error('Error parsing shortfeatures:', error);
        }
      }



    let html = `
      <div class="row">
        <div class="col-lg-7">
        <div class="quick-top-logo brand-logo mb-2"><img src="${logoUrl}" alt="${product.type} logo" style="max-height: 40px;"></div>
          <div class="quick-view-slider-wrapper">
            <div class="product__image-slider">
              ${images.map(img => `<div><div data-fancybox="gallery" data-src="${img}"><img src="${img}" alt=""></div></div>`).join('')}
            </div>
            <div class="product__image-thumbnail" ${maxWidthStyle}>
              
                ${images.map((img, index) => `
                  <div class="thumbnail" data-index="${index}">
                    <div class="quick-view-slider-thumb">
                      <img src="${img}" alt="">
                    </div>
                  </div>
                `).join('')}
              
            </div>
          </div>
        </div>
      
    <div class="col-lg-5 quick-view-right">
      ${logoUrl ? `<div class="brand-logo mb-2"><img src="${logoUrl}" alt="${product.type} logo" style="max-height: 40px;"></div>` : ''}
      <h2 class="quick-view-title">${product.title}</h2>
      <p class="quick-view-price">
      <span class="current-price">${price}</span>
        ${firstVariant.compare_at_price && parseFloat(firstVariant.compare_at_price) > parseFloat(firstVariant.price)
          ? `<span class="compare-at-price" style="text-decoration: line-through; color:#708090; margin-left: 10px;">${formatPrice(firstVariant.compare_at_price)}</span>`
          : ''}
        
      </p>
    `;

    if (product.options.length > 0) {
      html += `<div class="swatches-wrapper">`;
      product.options.forEach((option, index) => {
        html += `<div class="swatch-group" data-option-index="${index}">
          <label>${option.name}</label>
          <div class="swatches">`;

        option.values.forEach(value => {
          const isOptionAvailable = product.variants.some(variant =>
            variant.options[index] === value && variant.available
          );
          const isChecked = value === firstVariant.options[index] ? 'checked' : '';
          const isDisabled = !isOptionAvailable ? 'disabled' : '';
          const labelStyle = !isOptionAvailable ? 'style="text-decoration: line-through; opacity: 0.5;"' : '';

          html += `
            <label ${labelStyle}>
              <input type="radio" name="option${index}" value="${value}" ${isChecked} ${isDisabled}>
              <span>${value}</span>
            </label>
          `;
        });

        html += `</div></div>`;
      });
      html += `</div>`;
      
    }

    html += `
      ${featuresHtml}
      ${desc}
      <div class="quantity-wrapper">
        <label>Quantity</label>
        <input type="number" name="quantity" value="1" min="1">
      </div>

      <button class="btn dark-grey-button quick-view-add-to-cart mt-5" data-variant-id="${firstVariant.id}">
        <b>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M12.207 0.939C12.207 0.689962 12.1081 0.451123 11.932 0.275027C11.7559 0.09893 11.5171 0 11.268 0C11.019 0 10.7802 0.09893 10.6041 0.275027C10.428 0.451123 10.329 0.689962 10.329 0.939V7.202L8.17503 5.022C8.08838 4.93383 7.98503 4.86381 7.87103 4.816C7.75703 4.7682 7.63465 4.74358 7.51103 4.74358C7.38741 4.74358 7.26503 4.7682 7.15102 4.816C7.03702 4.86381 6.93368 4.93383 6.84703 5.022C6.67083 5.2015 6.57211 5.44298 6.57211 5.6945C6.57211 5.94602 6.67083 6.1875 6.84703 6.367L10.604 10.167C10.6907 10.2552 10.794 10.3252 10.908 10.373C11.022 10.4208 11.1444 10.4454 11.268 10.4454C11.3916 10.4454 11.514 10.4208 11.628 10.373C11.742 10.3252 11.8454 10.2552 11.932 10.167L15.689 6.367C15.8652 6.1875 15.9639 5.94602 15.9639 5.6945C15.9639 5.44298 15.8652 5.2015 15.689 5.022C15.6024 4.93383 15.499 4.86381 15.385 4.816C15.271 4.7682 15.1486 4.74358 15.025 4.74358C14.9014 4.74358 14.779 4.7682 14.665 4.816C14.551 4.86381 14.4477 4.93383 14.361 5.022L12.207 7.202V0.939ZM2.62787e-05 1.89C-0.000764158 1.7659 0.0228971 1.64286 0.0696589 1.5279C0.116421 1.41295 0.185367 1.30833 0.272562 1.22002C0.359757 1.13171 0.463492 1.06144 0.577844 1.01322C0.692196 0.965007 0.814926 0.939785 0.939026 0.939H1.38003C2.0017 0.941124 2.60529 1.1484 3.09711 1.52866C3.58893 1.90891 3.94147 2.44088 4.10003 3.042L4.49103 4.494L6.35003 11.4H16.186L18.045 4.493C18.0765 4.37301 18.1314 4.26044 18.2066 4.16182C18.2819 4.0632 18.3759 3.98047 18.4833 3.91844C18.5907 3.85641 18.7094 3.8163 18.8324 3.80043C18.9554 3.78456 19.0804 3.79325 19.2 3.826C19.4418 3.89436 19.6467 4.05548 19.7701 4.27427C19.8935 4.49305 19.9255 4.75175 19.859 4.994L18 11.9C17.894 12.3002 17.659 12.6542 17.3314 12.9073C17.0039 13.1604 16.602 13.2984 16.188 13.3H6.57203V14.251C6.57124 14.3751 6.5949 14.4981 6.64166 14.6131C6.68842 14.7281 6.75737 14.8327 6.84456 14.921C6.93176 15.0093 7.03549 15.0796 7.14984 15.1278C7.2642 15.176 7.38693 15.2012 7.51103 15.202H15.964C16.0881 15.2028 16.2109 15.228 16.3252 15.2762C16.4396 15.3244 16.5433 15.3947 16.6305 15.483C16.7177 15.5713 16.7866 15.6759 16.8334 15.7909C16.8802 15.9059 16.9038 16.0289 16.903 16.153C16.9032 16.3465 16.8446 16.5355 16.735 16.695C16.8463 16.9764 16.9033 17.2764 16.903 17.579C16.903 18.2023 16.6554 18.8 16.2147 19.2407C15.774 19.6814 15.1763 19.929 14.553 19.929C13.9298 19.929 13.332 19.6814 12.8913 19.2407C12.4506 18.8 12.203 18.2023 12.203 17.579C12.2029 17.4192 12.2187 17.2597 12.25 17.103H9.34203C9.37338 17.2597 9.38912 17.4192 9.38903 17.579C9.38646 17.9588 9.2918 18.3323 9.11316 18.6675C8.93453 19.0027 8.67725 19.2895 8.3634 19.5034C8.04955 19.7173 7.68849 19.8519 7.3112 19.8956C6.93392 19.9392 6.55166 19.8908 6.19723 19.7543C5.8428 19.6178 5.52677 19.3973 5.27625 19.1118C5.02574 18.8264 4.84821 18.4844 4.75891 18.1152C4.6696 17.7461 4.67119 17.3608 4.76352 16.9923C4.85585 16.6239 5.03618 16.2834 5.28903 16C4.90381 15.4981 4.69564 14.8827 4.69703 14.25V12.479L2.67703 4.993L2.28603 3.542C2.23302 3.34192 2.11552 3.1649 1.95173 3.03836C1.78795 2.91181 1.587 2.8428 1.38003 2.842H0.936026C0.685743 2.83962 0.446625 2.73805 0.271145 2.55957C0.0956664 2.38109 -0.00183904 2.14029 2.62787e-05 1.89ZM14.086 17.582C14.087 17.4893 14.1154 17.3989 14.1677 17.3223C14.2199 17.2456 14.2936 17.1862 14.3796 17.1514C14.4656 17.1166 14.5599 17.108 14.6507 17.1266C14.7416 17.1453 14.8249 17.1905 14.8901 17.2564C14.9553 17.3223 14.9996 17.4061 15.0173 17.4971C15.0351 17.5882 15.0255 17.6824 14.9898 17.768C14.954 17.8536 14.8938 17.9267 14.8166 17.9781C14.7394 18.0296 14.6488 18.057 14.556 18.057C14.4308 18.0562 14.3109 18.0057 14.2228 17.9167C14.1347 17.8276 14.0855 17.7073 14.086 17.582ZM6.57203 17.582C6.57301 17.4893 6.60141 17.3989 6.65365 17.3223C6.70589 17.2456 6.77964 17.1862 6.8656 17.1514C6.95157 17.1166 7.04591 17.108 7.13675 17.1266C7.22758 17.1453 7.31086 17.1905 7.37609 17.2564C7.44132 17.3223 7.48559 17.4061 7.50333 17.4971C7.52106 17.5882 7.51147 17.6824 7.47575 17.768C7.44004 17.8536 7.3798 17.9267 7.30262 17.9781C7.22544 18.0296 7.13477 18.057 7.04203 18.057C6.91675 18.0562 6.79691 18.0057 6.7088 17.9167C6.62068 17.8276 6.57149 17.7073 6.57203 17.582Z" fill="white"></path>
              </svg>
            </b>
        <span>Add to Cart</span>
      </button>
      <div class="view-link"><a href="${productHandle}">View More</a></div>
      
    `;

    html += `</div></div>`;

    modalContent.innerHTML = html;

    const addToCartBtn = modalContent.querySelector('.quick-view-add-to-cart');
    if (!firstVariant.available) {
      addToCartBtn.disabled = true;
       addToCartBtn.innerHTML = '<span>Out of Stock</span>';
    }

    openModal(product);
    handleSwatchChange(product);
    handleAddToCart();
  }

  function handleSwatchChange(product) {
  const radios = document.querySelectorAll('.swatches input[type=radio]');
  const priceElement = document.querySelector('.quick-view-price');
  const slider = $('.product__image-slider');
  const addToCartBtn = document.querySelector('.quick-view-add-to-cart');

  radios.forEach(radio => {
    radio.addEventListener('change', function () {
      const selectedOptions = [];
      document.querySelectorAll('.swatch-group').forEach((group, index) => {
        const selected = group.querySelector('input[type=radio]:checked');
        if (selected) {
          selectedOptions[index] = selected.value;
        }
      });

      const matchedVariant = product.variants.find(variant =>
        variant.options.every((opt, idx) => opt === selectedOptions[idx])
      );

      if (matchedVariant) {
        // 🛠 Handle price and compare-at-price display
        let priceHtml = '';
        const price = parseFloat(matchedVariant.price);
        const compareAt = parseFloat(matchedVariant.compare_at_price);

        if (compareAt && compareAt > price) {
          // Show both compare at and discounted price
          priceHtml += `
          <span class="current-price">${formatPrice(price)}</span>
            <span class="compare-at-price" style="text-decoration: line-through; color: #708090; margin-left: 10px;">
              ${formatPrice(compareAt)}
            </span>
            
          `;
        } else {
          // Show only regular price
          priceHtml += `<span class="current-price">${formatPrice(price)}</span>`;
        }

        priceElement.innerHTML = priceHtml;

        // Update variant ID for Add to Cart
        addToCartBtn.setAttribute('data-variant-id', matchedVariant.id);

        // Handle stock availability
        if (!matchedVariant.available) {
          addToCartBtn.disabled = true;
          addToCartBtn.innerHTML = `<b>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M12.207 0.939C12.207 0.689962 12.1081 0.451123 11.932 0.275027C11.7559 0.09893 11.5171 0 11.268 0C11.019 0 10.7802 0.09893 10.6041 0.275027C10.428 0.451123 10.329 0.689962 10.329 0.939V7.202L8.17503 5.022C8.08838 4.93383 7.98503 4.86381 7.87103 4.816C7.75703 4.7682 7.63465 4.74358 7.51103 4.74358C7.38741 4.74358 7.26503 4.7682 7.15102 4.816C7.03702 4.86381 6.93368 4.93383 6.84703 5.022C6.67083 5.2015 6.57211 5.44298 6.57211 5.6945C6.57211 5.94602 6.67083 6.1875 6.84703 6.367L10.604 10.167C10.6907 10.2552 10.794 10.3252 10.908 10.373C11.022 10.4208 11.1444 10.4454 11.268 10.4454C11.3916 10.4454 11.514 10.4208 11.628 10.373C11.742 10.3252 11.8454 10.2552 11.932 10.167L15.689 6.367C15.8652 6.1875 15.9639 5.94602 15.9639 5.6945C15.9639 5.44298 15.8652 5.2015 15.689 5.022C15.6024 4.93383 15.499 4.86381 15.385 4.816C15.271 4.7682 15.1486 4.74358 15.025 4.74358C14.9014 4.74358 14.779 4.7682 14.665 4.816C14.551 4.86381 14.4477 4.93383 14.361 5.022L12.207 7.202V0.939ZM2.62787e-05 1.89C-0.000764158 1.7659 0.0228971 1.64286 0.0696589 1.5279C0.116421 1.41295 0.185367 1.30833 0.272562 1.22002C0.359757 1.13171 0.463492 1.06144 0.577844 1.01322C0.692196 0.965007 0.814926 0.939785 0.939026 0.939H1.38003C2.0017 0.941124 2.60529 1.1484 3.09711 1.52866C3.58893 1.90891 3.94147 2.44088 4.10003 3.042L4.49103 4.494L6.35003 11.4H16.186L18.045 4.493C18.0765 4.37301 18.1314 4.26044 18.2066 4.16182C18.2819 4.0632 18.3759 3.98047 18.4833 3.91844C18.5907 3.85641 18.7094 3.8163 18.8324 3.80043C18.9554 3.78456 19.0804 3.79325 19.2 3.826C19.4418 3.89436 19.6467 4.05548 19.7701 4.27427C19.8935 4.49305 19.9255 4.75175 19.859 4.994L18 11.9C17.894 12.3002 17.659 12.6542 17.3314 12.9073C17.0039 13.1604 16.602 13.2984 16.188 13.3H6.57203V14.251C6.57124 14.3751 6.5949 14.4981 6.64166 14.6131C6.68842 14.7281 6.75737 14.8327 6.84456 14.921C6.93176 15.0093 7.03549 15.0796 7.14984 15.1278C7.2642 15.176 7.38693 15.2012 7.51103 15.202H15.964C16.0881 15.2028 16.2109 15.228 16.3252 15.2762C16.4396 15.3244 16.5433 15.3947 16.6305 15.483C16.7177 15.5713 16.7866 15.6759 16.8334 15.7909C16.8802 15.9059 16.9038 16.0289 16.903 16.153C16.9032 16.3465 16.8446 16.5355 16.735 16.695C16.8463 16.9764 16.9033 17.2764 16.903 17.579C16.903 18.2023 16.6554 18.8 16.2147 19.2407C15.774 19.6814 15.1763 19.929 14.553 19.929C13.9298 19.929 13.332 19.6814 12.8913 19.2407C12.4506 18.8 12.203 18.2023 12.203 17.579C12.2029 17.4192 12.2187 17.2597 12.25 17.103H9.34203C9.37338 17.2597 9.38912 17.4192 9.38903 17.579C9.38646 17.9588 9.2918 18.3323 9.11316 18.6675C8.93453 19.0027 8.67725 19.2895 8.3634 19.5034C8.04955 19.7173 7.68849 19.8519 7.3112 19.8956C6.93392 19.9392 6.55166 19.8908 6.19723 19.7543C5.8428 19.6178 5.52677 19.3973 5.27625 19.1118C5.02574 18.8264 4.84821 18.4844 4.75891 18.1152C4.6696 17.7461 4.67119 17.3608 4.76352 16.9923C4.85585 16.6239 5.03618 16.2834 5.28903 16C4.90381 15.4981 4.69564 14.8827 4.69703 14.25V12.479L2.67703 4.993L2.28603 3.542C2.23302 3.34192 2.11552 3.1649 1.95173 3.03836C1.78795 2.91181 1.587 2.8428 1.38003 2.842H0.936026C0.685743 2.83962 0.446625 2.73805 0.271145 2.55957C0.0956664 2.38109 -0.00183904 2.14029 2.62787e-05 1.89ZM14.086 17.582C14.087 17.4893 14.1154 17.3989 14.1677 17.3223C14.2199 17.2456 14.2936 17.1862 14.3796 17.1514C14.4656 17.1166 14.5599 17.108 14.6507 17.1266C14.7416 17.1453 14.8249 17.1905 14.8901 17.2564C14.9553 17.3223 14.9996 17.4061 15.0173 17.4971C15.0351 17.5882 15.0255 17.6824 14.9898 17.768C14.954 17.8536 14.8938 17.9267 14.8166 17.9781C14.7394 18.0296 14.6488 18.057 14.556 18.057C14.4308 18.0562 14.3109 18.0057 14.2228 17.9167C14.1347 17.8276 14.0855 17.7073 14.086 17.582ZM6.57203 17.582C6.57301 17.4893 6.60141 17.3989 6.65365 17.3223C6.70589 17.2456 6.77964 17.1862 6.8656 17.1514C6.95157 17.1166 7.04591 17.108 7.13675 17.1266C7.22758 17.1453 7.31086 17.1905 7.37609 17.2564C7.44132 17.3223 7.48559 17.4061 7.50333 17.4971C7.52106 17.5882 7.51147 17.6824 7.47575 17.768C7.44004 17.8536 7.3798 17.9267 7.30262 17.9781C7.22544 18.0296 7.13477 18.057 7.04203 18.057C6.91675 18.0562 6.79691 18.0057 6.7088 17.9167C6.62068 17.8276 6.57149 17.7073 6.57203 17.582Z" fill="white"></path>
              </svg>
            </b><span>Out of Stock</span>`;
        } else {
          addToCartBtn.disabled = false;
          addToCartBtn.innerHTML = `<b>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M12.207 0.939C12.207 0.689962 12.1081 0.451123 11.932 0.275027C11.7559 0.09893 11.5171 0 11.268 0C11.019 0 10.7802 0.09893 10.6041 0.275027C10.428 0.451123 10.329 0.689962 10.329 0.939V7.202L8.17503 5.022C8.08838 4.93383 7.98503 4.86381 7.87103 4.816C7.75703 4.7682 7.63465 4.74358 7.51103 4.74358C7.38741 4.74358 7.26503 4.7682 7.15102 4.816C7.03702 4.86381 6.93368 4.93383 6.84703 5.022C6.67083 5.2015 6.57211 5.44298 6.57211 5.6945C6.57211 5.94602 6.67083 6.1875 6.84703 6.367L10.604 10.167C10.6907 10.2552 10.794 10.3252 10.908 10.373C11.022 10.4208 11.1444 10.4454 11.268 10.4454C11.3916 10.4454 11.514 10.4208 11.628 10.373C11.742 10.3252 11.8454 10.2552 11.932 10.167L15.689 6.367C15.8652 6.1875 15.9639 5.94602 15.9639 5.6945C15.9639 5.44298 15.8652 5.2015 15.689 5.022C15.6024 4.93383 15.499 4.86381 15.385 4.816C15.271 4.7682 15.1486 4.74358 15.025 4.74358C14.9014 4.74358 14.779 4.7682 14.665 4.816C14.551 4.86381 14.4477 4.93383 14.361 5.022L12.207 7.202V0.939ZM2.62787e-05 1.89C-0.000764158 1.7659 0.0228971 1.64286 0.0696589 1.5279C0.116421 1.41295 0.185367 1.30833 0.272562 1.22002C0.359757 1.13171 0.463492 1.06144 0.577844 1.01322C0.692196 0.965007 0.814926 0.939785 0.939026 0.939H1.38003C2.0017 0.941124 2.60529 1.1484 3.09711 1.52866C3.58893 1.90891 3.94147 2.44088 4.10003 3.042L4.49103 4.494L6.35003 11.4H16.186L18.045 4.493C18.0765 4.37301 18.1314 4.26044 18.2066 4.16182C18.2819 4.0632 18.3759 3.98047 18.4833 3.91844C18.5907 3.85641 18.7094 3.8163 18.8324 3.80043C18.9554 3.78456 19.0804 3.79325 19.2 3.826C19.4418 3.89436 19.6467 4.05548 19.7701 4.27427C19.8935 4.49305 19.9255 4.75175 19.859 4.994L18 11.9C17.894 12.3002 17.659 12.6542 17.3314 12.9073C17.0039 13.1604 16.602 13.2984 16.188 13.3H6.57203V14.251C6.57124 14.3751 6.5949 14.4981 6.64166 14.6131C6.68842 14.7281 6.75737 14.8327 6.84456 14.921C6.93176 15.0093 7.03549 15.0796 7.14984 15.1278C7.2642 15.176 7.38693 15.2012 7.51103 15.202H15.964C16.0881 15.2028 16.2109 15.228 16.3252 15.2762C16.4396 15.3244 16.5433 15.3947 16.6305 15.483C16.7177 15.5713 16.7866 15.6759 16.8334 15.7909C16.8802 15.9059 16.9038 16.0289 16.903 16.153C16.9032 16.3465 16.8446 16.5355 16.735 16.695C16.8463 16.9764 16.9033 17.2764 16.903 17.579C16.903 18.2023 16.6554 18.8 16.2147 19.2407C15.774 19.6814 15.1763 19.929 14.553 19.929C13.9298 19.929 13.332 19.6814 12.8913 19.2407C12.4506 18.8 12.203 18.2023 12.203 17.579C12.2029 17.4192 12.2187 17.2597 12.25 17.103H9.34203C9.37338 17.2597 9.38912 17.4192 9.38903 17.579C9.38646 17.9588 9.2918 18.3323 9.11316 18.6675C8.93453 19.0027 8.67725 19.2895 8.3634 19.5034C8.04955 19.7173 7.68849 19.8519 7.3112 19.8956C6.93392 19.9392 6.55166 19.8908 6.19723 19.7543C5.8428 19.6178 5.52677 19.3973 5.27625 19.1118C5.02574 18.8264 4.84821 18.4844 4.75891 18.1152C4.6696 17.7461 4.67119 17.3608 4.76352 16.9923C4.85585 16.6239 5.03618 16.2834 5.28903 16C4.90381 15.4981 4.69564 14.8827 4.69703 14.25V12.479L2.67703 4.993L2.28603 3.542C2.23302 3.34192 2.11552 3.1649 1.95173 3.03836C1.78795 2.91181 1.587 2.8428 1.38003 2.842H0.936026C0.685743 2.83962 0.446625 2.73805 0.271145 2.55957C0.0956664 2.38109 -0.00183904 2.14029 2.62787e-05 1.89ZM14.086 17.582C14.087 17.4893 14.1154 17.3989 14.1677 17.3223C14.2199 17.2456 14.2936 17.1862 14.3796 17.1514C14.4656 17.1166 14.5599 17.108 14.6507 17.1266C14.7416 17.1453 14.8249 17.1905 14.8901 17.2564C14.9553 17.3223 14.9996 17.4061 15.0173 17.4971C15.0351 17.5882 15.0255 17.6824 14.9898 17.768C14.954 17.8536 14.8938 17.9267 14.8166 17.9781C14.7394 18.0296 14.6488 18.057 14.556 18.057C14.4308 18.0562 14.3109 18.0057 14.2228 17.9167C14.1347 17.8276 14.0855 17.7073 14.086 17.582ZM6.57203 17.582C6.57301 17.4893 6.60141 17.3989 6.65365 17.3223C6.70589 17.2456 6.77964 17.1862 6.8656 17.1514C6.95157 17.1166 7.04591 17.108 7.13675 17.1266C7.22758 17.1453 7.31086 17.1905 7.37609 17.2564C7.44132 17.3223 7.48559 17.4061 7.50333 17.4971C7.52106 17.5882 7.51147 17.6824 7.47575 17.768C7.44004 17.8536 7.3798 17.9267 7.30262 17.9781C7.22544 18.0296 7.13477 18.057 7.04203 18.057C6.91675 18.0562 6.79691 18.0057 6.7088 17.9167C6.62068 17.8276 6.57149 17.7073 6.57203 17.582Z" fill="white"></path>
              </svg>
            </b><span>Add to Cart</span>`;
        }

        // Update image slider if variant has its own image
        if (matchedVariant.featured_image) {
          const variantImage = matchedVariant.featured_image.src.split('/').pop();
          const matchedIndex = product.images.findIndex(img => img.includes(variantImage));
          if (matchedIndex !== -1) {
            slider.slick('slickGoTo', matchedIndex);
          }
        }
      }
    });
  });
}


 function handleAddToCart() {
  document.querySelector('.quick-view-add-to-cart').addEventListener('click', function () {
    const button = this;
    const variantId = this.getAttribute('data-variant-id');
    const quantity = parseInt(document.querySelector('input[name="quantity"]').value || 1);

    if (!variantId) return;

    // Disable the button and show a loading state
    button.disabled = true;
    button.innerHTML = 'Adding to Cart...';  // Optionally change text for visual feedback

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity: quantity,
      }),
    })
    .then(() => {
      // Close Quick View popup
      document.querySelector('.quick-view-popup')?.classList.remove('open');

      // Fetch updated cart sections
      return fetch('/?sections=cart-drawer,cart-icon-bubble');
    })
    .then(res => res.json())
    .then(parsedState => {
      // Trigger the renderContents method from the existing <cart-drawer> element
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        cartDrawer.classList.remove('is-empty'); // Remove the "is-empty" class
      }
      if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
        cartDrawer.renderContents({
          id: variantId,
          sections: parsedState
        });
      }
    })
    .catch(err => {
      console.error('Add to cart error:', err);
    })
    .finally(() => {
      // Re-enable the button after the request is complete
      button.disabled = false;
      button.innerHTML = `<b>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M12.207 0.939C12.207 0.689962 12.1081 0.451123 11.932 0.275027C11.7559 0.09893 11.5171 0 11.268 0C11.019 0 10.7802 0.09893 10.6041 0.275027C10.428 0.451123 10.329 0.689962 10.329 0.939V7.202L8.17503 5.022C8.08838 4.93383 7.98503 4.86381 7.87103 4.816C7.75703 4.7682 7.63465 4.74358 7.51103 4.74358C7.38741 4.74358 7.26503 4.7682 7.15102 4.816C7.03702 4.86381 6.93368 4.93383 6.84703 5.022C6.67083 5.2015 6.57211 5.44298 6.57211 5.6945C6.57211 5.94602 6.67083 6.1875 6.84703 6.367L10.604 10.167C10.6907 10.2552 10.794 10.3252 10.908 10.373C11.022 10.4208 11.1444 10.4454 11.268 10.4454C11.3916 10.4454 11.514 10.4208 11.628 10.373C11.742 10.3252 11.8454 10.2552 11.932 10.167L15.689 6.367C15.8652 6.1875 15.9639 5.94602 15.9639 5.6945C15.9639 5.44298 15.8652 5.2015 15.689 5.022C15.6024 4.93383 15.499 4.86381 15.385 4.816C15.271 4.7682 15.1486 4.74358 15.025 4.74358C14.9014 4.74358 14.779 4.7682 14.665 4.816C14.551 4.86381 14.4477 4.93383 14.361 5.022L12.207 7.202V0.939ZM2.62787e-05 1.89C-0.000764158 1.7659 0.0228971 1.64286 0.0696589 1.5279C0.116421 1.41295 0.185367 1.30833 0.272562 1.22002C0.359757 1.13171 0.463492 1.06144 0.577844 1.01322C0.692196 0.965007 0.814926 0.939785 0.939026 0.939H1.38003C2.0017 0.941124 2.60529 1.1484 3.09711 1.52866C3.58893 1.90891 3.94147 2.44088 4.10003 3.042L4.49103 4.494L6.35003 11.4H16.186L18.045 4.493C18.0765 4.37301 18.1314 4.26044 18.2066 4.16182C18.2819 4.0632 18.3759 3.98047 18.4833 3.91844C18.5907 3.85641 18.7094 3.8163 18.8324 3.80043C18.9554 3.78456 19.0804 3.79325 19.2 3.826C19.4418 3.89436 19.6467 4.05548 19.7701 4.27427C19.8935 4.49305 19.9255 4.75175 19.859 4.994L18 11.9C17.894 12.3002 17.659 12.6542 17.3314 12.9073C17.0039 13.1604 16.602 13.2984 16.188 13.3H6.57203V14.251C6.57124 14.3751 6.5949 14.4981 6.64166 14.6131C6.68842 14.7281 6.75737 14.8327 6.84456 14.921C6.93176 15.0093 7.03549 15.0796 7.14984 15.1278C7.2642 15.176 7.38693 15.2012 7.51103 15.202H15.964C16.0881 15.2028 16.2109 15.228 16.3252 15.2762C16.4396 15.3244 16.5433 15.3947 16.6305 15.483C16.7177 15.5713 16.7866 15.6759 16.8334 15.7909C16.8802 15.9059 16.9038 16.0289 16.903 16.153C16.9032 16.3465 16.8446 16.5355 16.735 16.695C16.8463 16.9764 16.9033 17.2764 16.903 17.579C16.903 18.2023 16.6554 18.8 16.2147 19.2407C15.774 19.6814 15.1763 19.929 14.553 19.929C13.9298 19.929 13.332 19.6814 12.8913 19.2407C12.4506 18.8 12.203 18.2023 12.203 17.579C12.2029 17.4192 12.2187 17.2597 12.25 17.103H9.34203C9.37338 17.2597 9.38912 17.4192 9.38903 17.579C9.38646 17.9588 9.2918 18.3323 9.11316 18.6675C8.93453 19.0027 8.67725 19.2895 8.3634 19.5034C8.04955 19.7173 7.68849 19.8519 7.3112 19.8956C6.93392 19.9392 6.55166 19.8908 6.19723 19.7543C5.8428 19.6178 5.52677 19.3973 5.27625 19.1118C5.02574 18.8264 4.84821 18.4844 4.75891 18.1152C4.6696 17.7461 4.67119 17.3608 4.76352 16.9923C4.85585 16.6239 5.03618 16.2834 5.28903 16C4.90381 15.4981 4.69564 14.8827 4.69703 14.25V12.479L2.67703 4.993L2.28603 3.542C2.23302 3.34192 2.11552 3.1649 1.95173 3.03836C1.78795 2.91181 1.587 2.8428 1.38003 2.842H0.936026C0.685743 2.83962 0.446625 2.73805 0.271145 2.55957C0.0956664 2.38109 -0.00183904 2.14029 2.62787e-05 1.89ZM14.086 17.582C14.087 17.4893 14.1154 17.3989 14.1677 17.3223C14.2199 17.2456 14.2936 17.1862 14.3796 17.1514C14.4656 17.1166 14.5599 17.108 14.6507 17.1266C14.7416 17.1453 14.8249 17.1905 14.8901 17.2564C14.9553 17.3223 14.9996 17.4061 15.0173 17.4971C15.0351 17.5882 15.0255 17.6824 14.9898 17.768C14.954 17.8536 14.8938 17.9267 14.8166 17.9781C14.7394 18.0296 14.6488 18.057 14.556 18.057C14.4308 18.0562 14.3109 18.0057 14.2228 17.9167C14.1347 17.8276 14.0855 17.7073 14.086 17.582ZM6.57203 17.582C6.57301 17.4893 6.60141 17.3989 6.65365 17.3223C6.70589 17.2456 6.77964 17.1862 6.8656 17.1514C6.95157 17.1166 7.04591 17.108 7.13675 17.1266C7.22758 17.1453 7.31086 17.1905 7.37609 17.2564C7.44132 17.3223 7.48559 17.4061 7.50333 17.4971C7.52106 17.5882 7.51147 17.6824 7.47575 17.768C7.44004 17.8536 7.3798 17.9267 7.30262 17.9781C7.22544 18.0296 7.13477 18.057 7.04203 18.057C6.91675 18.0562 6.79691 18.0057 6.7088 17.9167C6.62068 17.8276 6.57149 17.7073 6.57203 17.582Z" fill="white"></path>
              </svg>
            </b><span>Add to Cart</span>`;  // Restore the original text
    });
  });
}


  function fetchProductQuickView(handle, shortfeatures) {
    fetch(`/products/${handle}.js`)
      .then(res => res.json())
      .then(product => {
        buildQuickView(product, shortfeatures);
      });
  }

  function bindQuickViewButtons() {
    document.querySelectorAll('.quick-view-btn').forEach(button => {
      button.replaceWith(button.cloneNode(true));
    });

    document.querySelectorAll('.quick-view-btn').forEach(button => {
      button.addEventListener('click', function () {
        const handle = this.getAttribute('data-handle');
        var shortfeatures = $(this).attr('data-shortfeatures');
        fetchProductQuickView(handle, shortfeatures);
      });
    });
  }

  bindQuickViewButtons();

  function handlePodCartLinks() {
    document.querySelectorAll('.pod-cart-link').forEach(link => {
      if (link.dataset.bound === 'true') return;
      link.dataset.bound = 'true';
  
      // Skip if it has the disabled class
      if (link.classList.contains('disabled')) {
        link.setAttribute('aria-disabled', 'true');
        link.style.pointerEvents = 'none';
        link.style.opacity = '0.5'; // Optional visual cue
        return;
      }
  
      link.addEventListener('click', function (e) {
        e.preventDefault();
  
        const button = this;
        const variantId = button.dataset.variantId;
        const quantity = 1;
  
        if (!variantId) return;
  
        button.disabled = true;
        button.classList.add('is-loading');
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: quantity,
          }),
        })
        .then(() => fetch('/?sections=cart-drawer,cart-icon-bubble'))
        .then(res => res.json())
        .then(parsedState => {
          const cartDrawer = document.querySelector('cart-drawer');
          if (cartDrawer) {
            cartDrawer.classList.remove('is-empty');
            if (typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents({
                id: variantId,
                sections: parsedState
              });
            }
          }
        })
        .catch(err => console.error('Add to cart error:', err))
        .finally(() => {
          button.disabled = false;
          button.classList.remove('is-loading');
        });
      });
    });
  }
  
  // Initial bind
  document.addEventListener('DOMContentLoaded', handlePodCartLinks);

  window.addEventListener('globoFilterRenderCompleted', function () {
    bindQuickViewButtons();
    handlePodCartLinks();
  });

  document.querySelector('.quick-view-close').addEventListener('click', closeModal);
  document.querySelector('.quick-view-overlay').addEventListener('click', closeModal);
});
